import type { LinksFunction } from '@remix-run/node'
import { Outlet, useOutletContext } from '@remix-run/react'
import { ContentHeader } from '~/components'
import { Footer } from '~/components-v2/footer/footer'
import { useRef } from 'react'

// Editorial
import editorial from './editorial.css?url'
import { Flash, styles } from '~/components-v2'
import { codeBlockLinks } from '~/components-v2/code-block'

export const links: LinksFunction = () => [
  // general styles
  { rel: 'stylesheet', href: editorial },

  // layout
  { rel: 'stylesheet', href: styles.figure },
  { rel: 'stylesheet', href: styles.hero },
  { rel: 'stylesheet', href: styles.section },
  { rel: 'stylesheet', href: styles.stack },

  // components
  ...codeBlockLinks(),
  { rel: 'stylesheet', href: styles.anchorReveal },
]

export default function () {
  const mainRef = useRef<HTMLDivElement>(null)
  return (
    <>
      <Flash />
      <ContentHeader mainRef={mainRef} />
      <Outlet context={useOutletContext()} />
      <Footer />
    </>
  )
}
